import { AxiosResponse} from "axios";
import DynamicObject from "../../models/dynamic-object";
import Api from "../api";

export default (data?: DynamicObject): Promise<AxiosResponse> => {
    const path = '/members/my-account'
    return Api.getInstance().request.post(`${path}`, data, path);
}